export class ConvertOtherSnapshotsOnDemandRequest {
    'vaultId';
    'retentionDays';
    'snapshotDetails';
    'azureRestorePoints';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": ""
        },
        {
            "name": "retentionDays",
            "baseName": "retentionDays",
            "type": "number",
            "format": ""
        },
        {
            "name": "snapshotDetails",
            "baseName": "snapshotDetails",
            "type": "Array<ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner>",
            "format": ""
        },
        {
            "name": "azureRestorePoints",
            "baseName": "azureRestorePoints",
            "type": "Array<AzureRestorePointSpec>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConvertOtherSnapshotsOnDemandRequest.attributeTypeMap;
    }
    constructor() {
    }
}
